module.exports = __webpack_public_path__ + "img/podoarttour_thumb_02.d2da0d07.jpg";